import styled from "@emotion/styled"
import css from "@styled-system/css"
import Flex from "./Flex"

// TODO: hardcoded. need to abstract to theme
const Row = styled(Flex)`
  ${css({
    mx: ["-8px", "0px", "-10px"],
    flexWrap: "wrap",
  })}
`

export default Row
